import { api } from "./base.api.ts"

export const deleteAccount = async () => {
  await api.delete("delete-account")
}

export const changePassword = async (password) => {
  await api.post("change-password", {
    password,
  })
}
